<template>
    <div class="col-md-12">
        <!--<div class="d-flex justify-content-between align-items-end mb-1">
            <div>&nbsp;</div>
            <b-form-group>
                <b-form-checkbox name="showDisabled"
                                 v-model="showDisabled"
                                 v-on:change="refreshGrid"
                                 switch
                                 class="mr-0">
                    Display Disabled Accounts
                </b-form-checkbox>
            </b-form-group>
        </div>-->
        <filter-ui :fields="filterFields" ref="usersFilter" :apiBaseUrl="apiBaseUrl" :filter="initialFilter" v-on:change="filterChanged"></filter-ui>
        <ejs-grid id="usersGrid"
                  ref="usersGrid"
                  :dataSource="gridData"
                  :allowSorting="true"
                  :sortSettings="sortSettings"
                  :toolbar="toolbar"
                  :allowGrouping="false"
                  :allowResizing="true"
                  :allowPaging="true"
                  :pageSettings="pageSettings"
                  :showColumnChooser="true"
                  :allowExcelExport="true"
                  :dataStateChange="gridDataStateChanged"
                  :queryCellInfo="customiseCell"
                  :excelQueryCellInfo="customiseCell"
                  :toolbarClick="toolbarClicked"
                  :rowSelected="rowSelectionChanged"
                  :rowDeselected="rowSelectionChanged"
                  :headerCellInfo="headerCellInfoEvent"
                  :rowDataBound="rowDataBound"
                  :created="gridCreated"
                  :enableStickyHeader="true">
            <e-columns>
                <e-column field="email" headerText="Email" width="100"></e-column>
                <e-column field="displayName" headerText="Name"></e-column>
                <e-column field="userRoleDisplayNames" headerText="User Roles" :allowSorting="false"></e-column>
                <e-column field="statusDisplayName" headerText="Status" :allowSorting="false"></e-column>
                <e-column field="initials" headerText="Initials" :allowSorting="false"></e-column>
                <e-column field="employmentTypeDisplayName" headerText="Employment Type" :allowSorting="false"></e-column>
                <e-column field="agvsaClearanceDisplayName" headerText="AGVSA Clearance" :allowSorting="false"></e-column>
                <e-column field="typistSkillLevelDisplayName" headerText="Typist Skill Level" :allowSorting="false"></e-column>
                <e-column field="reportingManagerDisplayName" headerText="Reporting Manager" :allowSorting="false"></e-column>
                <e-column field="reportingLocation" headerText="Reporting Location" :allowSorting="false"></e-column>
                <e-column field="createdDateTimeUTC" headerText="Created"></e-column>
            </e-columns>
        </ejs-grid>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import { GridPlugin, ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport } from '@syncfusion/ej2-vue-grids';
    import { DataManager } from "@syncfusion/ej2-data";
    import axios from 'axios';

    import Attachments from '../Attachments.vue';
    Vue.component('attachments', Attachments);
    Vue.use(Attachments);

    import VueCurrencyInput from 'vue-currency-input'
    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    import { extend, localize } from 'vee-validate';
    import { required, min_value, max_value, email } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('required', required);
    extend('min_value', min_value);
    extend('max_value', max_value);
    extend('email', email);
    localize('en', en);

    import FilterUI from './FilterUI';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import GridMixins from '../../mixins/GridMixins';
    import NumbersMixin from '../../mixins/NumbersMixin';
    import Select2 from '../Select2';

    Vue.use(BootstrapVue);
    Vue.use(GridPlugin)
    Vue.use(VueCurrencyInput);
    Vue.use(NumbersMixin);
    Vue.component('select2', Select2);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);

    export default {
        name: 'UsersGrid',
        mixins: [ErrorsMixin, DateTimeMixin, GridMixins, NumbersMixin],
        components: {
            'filter-ui': FilterUI,
        },
        provide: {
            grid: [ColumnChooser, Resize, Sort, Group, Page, Toolbar, Search, ExcelExport]
        },
        props: {
            apiBaseUrl: {
                type: String,
                required: true
            },
            allUserRoles: {
                type: Array,
                default: null
            },
            allUserStatuses: {
                type: Array,
                default: null
            },
            allEmploymentTypes: {
                type: Array,
                default: null
            },
            allAgvsaClearances: {
                type: Array,
                default: null
            },
            allTypistSkillLevels: {
                type: Array,
                default: null
            },
            allCourtRegistryOptions: {
                type: Array,
                default: null
            },
            allInterviewOrganisationOptions: {
                type: Array,
                default: null
            },
        },
        data: function () {
            return {
                //showDisabled: false,

                pageSettings: { pageSize: 10, pageSizes: [5, 10, 25, 50] },

                initialized: false,

                filterFields: [
                    {
                        field: "UserRole",
                        label: "User Role",
                        type: "multiselect",
                        options: this.allUserRoles,
                        placeholder: "Select User Role Values"
                    },
                    {
                        field: "UserStatus",
                        label: "User Status",
                        type: "multiselect",
                        options: this.allUserStatuses,
                        placeholder: "Select User Status Values"
                    },
                    {
                        field: "EmploymentType",
                        label: "Employment Type",
                        type: "multiselect",
                        options: this.allEmploymentTypes,
                        placeholder: "Select Employment Type Values"
                    },
                    {
                        field: "AGVSAClearance",
                        label: "AGVSA Clearance",
                        type: "multiselect",
                        options: this.allAgvsaClearances,
                        placeholder: "Select AGVSA Clearance Values"
                    },
                    {
                        field: "TypistSkillLevel",
                        label: "Typist Skill Level",
                        type: "multiselect",
                        options: this.allTypistSkillLevels,
                        placeholder: "Select Typist Skill Level Values"
                    },
                    {
                        field: "CourtRegistryId",
                        label: "Court/Tribunal/Other",
                        type: "multiselect",
                        options: this.allCourtRegistryOptions,
                        placeholder: "Select Court/Tribunal/Other Values"
                    },
                    {
                        field: "InterviewOrganisationId",
                        label: "Organisation",
                        type: "multiselect",
                        options: this.allInterviewOrganisationOptions,
                        placeholder: "Select Organisations"
                    },
                ],
                quickFilters: null,
                initialFilter: null,

                sortSettings: { columns: [{ field: "createdDateTimeUTC", direction: "Descending" }] },
                gridDataState: {
                    filter: null,
                    search: null,
                    sorted: [{ name: "reference", direction: "descending" }],
                    group: null,
                    skip: 0,
                    take: 10,
                    requiresCounts: true
                },
                gridData: { result: [], count: 0 },
                grid: null,

                //currentPayment: null,
                showErrors: false,
                currentErrors: null,

                columnFormats: {
                    'createdDateTimeUTC': {
                        type: 'datetime'
                    },
                },
            }
        },
        computed: {
            toolbar: function () {
                var toolbarItems = this.defaultEJ2DataGridToolbarItems({ grouping: false, export: true, columnchooser: true });
                toolbarItems =
                    toolbarItems.concat(
                        [
                            { text: "Enable", tooltipText: "Enable Account", prefixIcon: "fas fa-user-plus", id: "enableAccount" },
                            { text: "Disable", tooltipText: "Disable Account", prefixIcon: "fas fa-user-slash", id: "disableAccount" },
                        ]
                    );

                return toolbarItems;
            }
        },
        methods: {
            customiseCell: function (args) {
                if (args.column.field == 'email') {
                    args.cell.innerHTML = "<a href='" + this.$urlHelper.getPageUrl('UserAccounts/Edit', [args.data.userAccountId]) + "'>" + args.data.email + "</a>";
                }
                this.defaultEJ2DataGridQueryCellInfo(args, this.columnFormats);
            },

            filterChanged: function (filter) {
                this.gridDataState.filter = filter;
                if (this.initialized) this.grid.refresh();
            },
            gridDataStateChanged: function (args) {
                this.gridDataState.search = args.search;
                this.gridDataState.sorted = args.sorted;
                this.gridDataState.group = args.group;
                this.gridDataState.skip = args.skip;
                this.gridDataState.take = args.take;
                this.gridDataState.requiresCounts = args.requiresCounts;
                this.grid.showSpinner();
                this.loadUsers(this.gridDataState)
                    .then(result => {
                        if (result) {
                            this.gridData = result;
                        }
                        this.grid.hideSpinner();
                    });
            },
            toolbarClicked: function (args) {
                if (args.item.id === 'enableAccount') {
                    this.handleAction(args.item.id, this.grid.getSelectedRecords()[0]);
                } else if (args.item.id === 'disableAccount') {
                    this.handleAction(args.item.id, this.grid.getSelectedRecords()[0]);
                } else if (args.item.id === 'excelexport') {
                    //to properly export all data (and not just the entries displayed on the current page) we have to load everything first
                    //we do this by taking the current grid state (which includes the current filter and search and sort settings)
                    var gridDataState = {
                        ...this.gridDataState
                    };
                    //but reset the skip and take to 0 which will return everything and unset the requiresCounts cause we are not interseted in the totals
                    gridDataState.requiresCounts = false;
                    gridDataState.skip = 0;
                    gridDataState.take = 0;
                    this.grid.showSpinner();
                    this.loadUsers(gridDataState)
                        .then(result => {
                            //the result is either false if something failed during the axios request, or it will contain the list in the result property which is what we have to pass to the actual export
                            if (result) {
                                var query = this.grid.getDataModule().generateQuery(true);
                                var groupedData = new DataManager(result.result).executeLocal(query);
                                this.grid.excelExport({ dataSource: groupedData });
                            }
                            this.grid.hideSpinner();
                        });
                } else {
                    this.defaultEJ2DataGridToolbarClickHandler(args, this.grid);
                }
            },
            handleAction: function (action, selectedRow) {
                if (action === 'enableAccount') {
                    this.$bvModal.msgBoxConfirm(
                        [
                            this.$createElement(
                                'div',
                                {
                                    domProps:
                                    {
                                        innerHTML: "<p>Are you sure you want to ENABLE the user '" + selectedRow.displayName + "'?</p>"
                                    }
                                }
                            )
                        ],
                        {
                            title: 'Enable User',
                            size: 'md',
                            okVariant: 'success',
                            okTitle: 'Yes, ENABLE User',
                            cancelTitle: 'No, Do Not Enable',
                            centered: true
                        })
                        .then(value => {
                            if (value) {
                                this.enableAccount(selectedRow.userAccountId);
                                this.grid.refresh();
                            }
                        });
                }
                else if (action === 'disableAccount') {
                    this.$bvModal.msgBoxConfirm(
                        [
                            this.$createElement(
                                'div',
                                {
                                    domProps:
                                    {
                                        innerHTML: "<p>Are you sure you want to DISABLE the user '" + selectedRow.displayName + "'?</p>"
                                    }
                                }
                            )
                        ],
                        {
                            title: 'Disable User',
                            size: 'md',
                            okVariant: 'danger',
                            okTitle: 'Yes, DISABLE User',
                            cancelTitle: 'No, Do Not Disable',
                            centered: true
                        })
                        .then(value => {
                            if (value) {
                                this.disableAccount(selectedRow.userAccountId);
                                this.grid.refresh();
                            }
                        });
                }
            },
            rowSelectionChanged: function (args) {
                if (args.name == 'rowSelected') {
                    this.updateToolbarItems(this.grid.getSelectedRecords()[0])
                } else {
                    this.updateToolbarItems(null)
                }
            },
            rowDataBound: function (args) {
                if (args.data.statusDisplayName == "Disabled")
                    args.row.classList.add('user-disabled');
                else if (args.data.statusDisplayName == "Locked")
                    args.row.classList.add('user-locked');
                else if (args.data.statusDisplayName == "Not Validated")
                    args.row.classList.add('user-not-validated');
            },
            updateToolbarItems: function (item = null) {
                this.setToolbarItemState('enableAccount', (item != null) && (item.disabledDateTimeUTC != null));
                this.setToolbarItemState('disableAccount', (item != null) && (item.disabledDateTimeUTC == null));
            },
            setToolbarItemState: function (itemId, enabled) {
                this.grid.toolbarModule.enableItems([itemId], enabled);
            },

            loadUsers: function (gridDataState) {
                var filter = {
                    gridDataRequest: gridDataState,
                    //excludeLocked: !this.showDisabled,
                    //includeDisabled: this.showDisabled,
                };

                var url = this.$urlHelper.getApiUrl('UserAccount', 'listStaff');
                return axios
                    .post(url, JSON.stringify(filter), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        var gridData = response.data;
                        if (gridData && gridData.result) {
                            gridData.result = gridData.result.map((asr) => {
                                if (asr.createdDateTimeUTC) asr.createdDateTimeUTC = this.parseDateTime(asr.createdDateTimeUTC, true, true);
                                return asr;
                            });
                        }
                        return gridData;
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                        return false;
                    });
            },
            enableAccount: function (userAccountId) {
                var url = this.$urlHelper.getApiUrl('UserAccount', 'enable/' + userAccountId);
                axios
                    .get(url)
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.grid.refresh();
                    });
            },
            disableAccount: function (userAccountId) {
                var url = this.$urlHelper.getApiUrl('UserAccount', 'disable/' + userAccountId);
                axios
                    .get(url)
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.grid.refresh();
                    });
            },

            gridCreated: function () {
                Vue.nextTick(() => {
                    this.defaultEJ2DataGridCreatedHandler(this.grid);
                });
            },
            refreshGrid: function () {
                this.grid.refresh();
            }
        },
        mounted: function () {
            this.grid = this.$refs.usersGrid.ej2Instances;
            this.setupGridPersistence(this.grid);
            this.updateToolbarItems(this.grid, null);
            this.$refs.usersFilter.loadQuickFilters()
                .then(() => {
                    this.initialized = true;
                    setTimeout(() => {
                        this.grid.refresh();
                    }, 250);
                });
        }
    }
</script>
<style scoped>
    div >>> .user-disabled {
        background-color: #F5C6CB !important;
    }

    div >>> .user-not-validated {
        background-color: #FFEEBA !important;
    }

    div >>> .user-locked {
        background-color: #fed8b1 !important;
    }
</style>